<!-- Toolbar -->
<div class="toolbar" role="banner">
  <span>CAREER SHIFT</span>
</div>

<router-outlet></router-outlet>
